<p-toast key="global" />
<p-toast position="top-right" key="cart" appendTo="body">
  <ng-template let-message pTemplate="message">
    <div class="flex flex-col gap-2 w-[300px]">
      <div class="fs-14 text-gray-700 flex gap-4">
        <div class="bell-wrapper">
          <i class="pi pi-bell bell-icon"></i>
          <span class="badge"></span>
        </div> {{ message.detail }}
      </div>

      <div class="flex justify-end">
        <button class="bg-gray-700 text-white p-2 rounded-lg" (click)="message.data?.onContinue?.()">{{'SYSMESER0033' | translate}}
        </button>
      </div>
    </div>
  </ng-template>
</p-toast>
<app-loading-ui></app-loading-ui>
@if (isLoggedIn()) {
<div class="flex h-screen bg-gray-100">
  <app-sidebar [isCollapsed]="isSidebarCollapsed()" [isMobileOpen]="isMobileMenuOpen()"
    (closeMobileMenu)="isMobileMenuOpen.set(false)" (logout)="onLogout()" (toggleCollapse)="toggleDesktopSidebar()">
  </app-sidebar>

  <div class="flex-1 flex flex-col overflow-hidden">
    <app-header (toggleMobileMenu)="toggleMobileMenu()">
    </app-header>
    <main class="flex-1 overflow-x-hidden overflow-y-auto bg-gray-100">
      <div class="h-full">
        <router-outlet></router-outlet>
      </div>
    </main>
  </div>

</div>
} @else {
<app-login (loginSuccess)="onLoginSuccess()"></app-login>
}